import { render, staticRenderFns } from "./DeletePhoto.vue?vue&type=template&id=a093f77a&scoped=true&"
import script from "./DeletePhoto.vue?vue&type=script&lang=js&"
export * from "./DeletePhoto.vue?vue&type=script&lang=js&"
import style0 from "./DeletePhoto.vue?vue&type=style&index=0&id=a093f77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a093f77a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a093f77a')) {
      api.createRecord('a093f77a', component.options)
    } else {
      api.reload('a093f77a', component.options)
    }
    module.hot.accept("./DeletePhoto.vue?vue&type=template&id=a093f77a&scoped=true&", function () {
      api.rerender('a093f77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/DeletePhoto.vue"
export default component.exports